/* Terralite: two-goal cart rewards bar (free shipping + free gift). Companion to snippets/cart-rewards-bar.liquid.
   Listens to Pipeline's theme:cart:change (event.detail.cart is the cart JSON) and re-renders the bar in place.
   It never writes to the cart. Plan: _Redesign/Docs/SEASONAL-GIFT-PROMO-PLAN.md */
(function () {
  'use strict';
  if (window.tlCartRewards) return;
  window.tlCartRewards = true;

  function money(cents, format) {
    var n = (Math.max(0, cents) / 100);
    var s = n.toFixed(2).replace(/\.00$/, '');
    var whole = s.split('.')[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    s = s.indexOf('.') > -1 ? whole + '.' + s.split('.')[1] : whole;
    if (format && format.indexOf('{{') > -1) {
      return format.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, s);
    }
    return '$' + s;
  }
  function fill(template, amount, limit) {
    return template.replace('||amount||', '<b data-rw-amount>' + amount + '</b>').replace('||limit||', limit);
  }

  function render(el, subtotal) {
    var on = el.getAttribute('data-on') === 'true';
    var ship = +el.getAttribute('data-ship') || 0;
    var gift = +el.getAttribute('data-gift') || 0;
    var fmt = el.getAttribute('data-money-format') || '';
    var line = el.querySelector('[data-rw-line]');
    var sub = el.querySelector('[data-rw-sub]');
    var bar = el.querySelector('[data-rw-fill]');
    var card = el.querySelector('[data-rw-card]');
    var leg1 = el.querySelector('[data-rw-leg1]');
    var leg2 = el.querySelector('[data-rw-leg2]');
    var cap = on ? gift : ship;
    if (cap <= 0) cap = 1;
    var state = 'off', lineHtml = '', subHtml = '';
    var giftLimit = money(gift, fmt);

    if (!on) {
      lineHtml = subtotal >= ship ? el.getAttribute('data-t-ship-done') : fill(el.getAttribute('data-t-ship'), money(ship - subtotal, fmt), giftLimit);
    } else if (subtotal < ship) {
      state = 's1';
      lineHtml = fill(el.getAttribute('data-t-ship'), money(ship - subtotal, fmt), giftLimit);
      subHtml = fill(el.getAttribute('data-t-gift-before'), '', giftLimit);
    } else if (subtotal < gift) {
      state = 's2';
      lineHtml = el.getAttribute('data-t-ship-done');
      subHtml = fill(el.getAttribute('data-t-gift'), money(gift - subtotal, fmt), giftLimit);
    } else {
      state = 's3';
      lineHtml = el.getAttribute('data-t-unlocked');
      subHtml = el.getAttribute('data-t-ship-done');
    }

    el.setAttribute('data-state', state);
    if (line) line.innerHTML = lineHtml;
    if (sub) { sub.innerHTML = subHtml; sub.hidden = !subHtml; }
    if (bar) bar.style.width = Math.min(100, subtotal / cap * 100) + '%';
    if (leg1) leg1.classList.toggle('is-done', subtotal >= ship);
    if (leg2) leg2.classList.toggle('is-done', subtotal >= gift);
    if (card) {
      if (state === 's3') {
        if (card.hidden) {
          card.hidden = false;
          requestAnimationFrame(function () { requestAnimationFrame(function () { card.classList.add('is-in'); }); });
        }
      } else {
        card.classList.remove('is-in');
        card.hidden = true;
      }
    }
  }

  function subtotalOf(cart) {
    if (!cart) return null;
    if (typeof cart.items_subtotal_price === 'number') return cart.items_subtotal_price;
    if (typeof cart.total_price === 'number') return cart.total_price;
    return null;
  }
  function renderAll(subtotal) {
    document.querySelectorAll('[data-rw]').forEach(function (el) { render(el, subtotal); });
  }

  document.addEventListener('theme:cart:change', function (event) {
    var s = subtotalOf(event.detail && event.detail.cart);
    if (s !== null) { renderAll(s); return; }
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      var t = subtotalOf(cart); if (t !== null) renderAll(t);
    }).catch(function () {});
  });
})();
